<template>
  <b-tabs class="block__tabsSidebar">
    <b-tab v-for="(list,index) in lists" :key="index" :title="list.title">
      <div class="entete">
        <div class="title">{{list.subtitle}}</div>
        <div class="toggle">
          <span>{{content.labelAll}}</span>
          <ion-toggle 
            @ionChange="fetchAll($event,index)"
            mode="ios" >
          </ion-toggle>                  
        </div>
      </div>
      <b-list-group>
        <b-list-group-item v-for="(subList,index) in list.ranking" :key="index">
          <PuSkeleton :loading="isLoading" :count="1" width='100%'>
            <div class="bt-list left">
                <div class="target" :class="putTheRightClass(subList.target)">{{subList.target}}</div>
                <div class="ranking">{{index+1}}</div>
                <div class="fullname">{{subList.fullname}}</div>
            </div>
            <div class="right">
              {{subList.result}}
            </div>
          </PuSkeleton>
        </b-list-group-item>
      </b-list-group>
    </b-tab>
  </b-tabs>
</template>

<script>

import Utils from "../../Utils"
import { mapGetters } from 'vuex'
//
export default {
  name: "TabsSidebar",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getGeneral',
      ])
    },  
  props:{
    lists:{
      type:Object
    }
  },
  data(){
    return { 
      content:"",
      isPositif:false,
      isLoading:true,
    }
  },
  created (){
    this.content = this.getGeneral;
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000);      
  },    
  methods : {
    putTheRightClass (target){
      return Utils.getTheClass(target);
    },
    fetchAll (event,index){
      console.log(event.target.checked);
      console.log(`SHOULD FETCH ALL THE RESULT FOR ID = ${index}`);
    }
  },  
  mounted (){
  }
}
</script>